let languages = {
    sr : {
        insuranceType : {
            insurance1 : "Osiguranje učenika i studenata",
        },
        messages: {
            invalidMail:"Format e-mail adrese nije ispravan",
        },
        headerInsuranceName : "Osiguranje učenika i studenata",
        headingDates : "Trajanje osiguranja",
        headingData: "Podaci o ugovaraču/osiguraniku",
        datepickerStart : "Početak osiguranja:",
        datepickerEnd : "Kraj osiguranja:",
        contractor: "Ugovarač osiguranja",
        contractorTooltip: "Lice koje plaća/ugovara osiguranje",
        insured: "Osiguranik",
        insuredTooltip: "Lice koje se osigurava",
        fName: "ime",
        lName: "prezime",
        JMBG: "Matični broj",
        samePerson: "Ugovarač je ujedno i osiguranik ",
        samePersonTooltip:"Ostavite ovo čekirano ako je ugovarač ujedno i osiguranik",
        extension:"Proširenja pokrića",
        extensionSport:"Putnik je profesionalni sportista",
        extensionSportTooltip:"ukoliko nije izabrano, a svrha putovanja je profesionalno bavljenje sportom, osiguranik nema pravo na naknadu štete",
        consent : "Nudimo vam besplatnu uslugu primanja korisnih obavještenja putem kontakt podataka koje ste unijeli. Budite među prvima koji će biti upoznati sa našim promotivnim aktivnostima, pogodnostima, proizvodima i uslugama, nagradnim igrama, novostima i sl. Lovćen osiguranje će čuvati Vaše podatke shodno odredbama Zakona o zaštiti podataka o ličnosti Crne Gore. U svakom momentu možete da povučete datu saglasnost.",
        consentAgree: "Slažem se",
        emailInstructions: "Unosom svoje e-mail adrese saglasna/saglasan sam da se moja e-mail adresa koristi u svrhu međusobne poslovne komunikacije temeljem ugovora o osiguranju u kojem sam ili ću biti u svojstvu ugovarača. Klikom na Pošalji e-mail primićete e-mail koji sadrži verifikacioni kod. Kod prepišite ili kopirajte u odgovarajuće polje",
        sendMail: "Zatraži kod",
        code: "Verifikacioni kod",
        policyDuration: "trajanje polise",
        parent: "roditelj/staratelj"
    },
    en: {
        insuranceType : {
            insurance1 : "Pupil and student insurance",
        },
        messages: {
            invalidMail: "Email address format is invalid",
        },
        headingDates : "Duration of insurance",
        headingData:   "Data on the contractor / insured",
        datepickerStart : "Start of insurance:",
        datepickerEnd : "End of insurance:",
        contractor: "Contractor",
        contractorTooltip:"The person who pays / contracts the insurance",
        insured: "Insured",
        insuredTooltip: "Insured person",
        fName: "first name",
        lName: "last name",
        JMBG: "ID number",
        samePerson: "Contractor is insured person",
        samePersonTooltip:"Leave this checked if contractor is insured person",
        extension:"Coverage extensions",
        extensionSport:"The traveler is a professional athlete",
        extensionSportTooltip:"if it is not chosen, and the purpose of the trip is professional sports, the insured is not entitled to compensation",
        consent: "We would like to occasionally send you news and offers by email, SMS, mail, phone and other electronic forms of communication. Lovćen Osiguranje will keep your data with the utmost care and will not share it with third parties under any circumstances. You can withdraw your consent at any time.",
        consentAgree: "Agree",
        emailInstructions: "By entering my e-mail address, I agree that my e-mail address is used for the purpose of mutual business communication on the basis of an insurance contract in which I am or will be a contractor. By clicking on Send e-mail you will receive an e-mail containing the verification code. Copy or copy the code to the appropriate field",
        sendMail:"Ask for a code",
        code: "Verification code",
        policyDuration:"policy duration",
        parent: "parent/guardian"
    },
};

export default languages;
